<template>
    <b-nav-item-dropdown
        class="dropdown-notification mr-25"
        menu-class="dropdown-menu-media"
        right
        lazy
        @show="cargarNotificationes()"
    >
        <template #button-content>
            <feather-icon
                :badge="`${getNotificationsCount}${getNotificationsCount >= 20 ? '+' : ''}`"
                badge-classes="bg-primary"
                class="text-body"
                icon="BellIcon"
                size="21"
            />
        </template>

        <!-- Header -->
        <li class="dropdown-menu-header">
            <div class="dropdown-header d-flex">
                <h4 class="notification-title mb-0 mr-auto">Notificaciones</h4>
                <b-badge
                    pill
                    variant="light-primary"
                >
                    {{ `${getNotifications.length} ${$t('general.nuevas')}` }}
                </b-badge>
            </div>
        </li>

        <!-- Notifications -->
        <b-overlay
            :show="show"
            rounded="sm"
        >
            <vue-perfect-scrollbar
                :settings="perfectScrollbarSettings"
                class="scrollable-container media-list scroll-area"
                tagname="li"
            >
                <!-- Account Notification -->
                <b-link
                    v-for="notification in getNotifications"
                    :key="notification.id"
                >
                    <b-media
                        right-align
                        vertical-align="center"
                    >
                        <template #aside>
                            <font-awesome-icon
                                class="notification-icon"
                                icon="fa-solid fa-xmark"
                                size="lg"
                                fade
                                @click="deleteNotification(notification.id)"
                            />
                        </template>

                        <b-media class="border-none">
                            <template #aside>
                                <b-avatar
                                    size="32"
                                    variant="primary"
                                >
                                    <template v-if="notification.icon">
                                        <b-img
                                            v-if="notification.icon.includes('//')"
                                            :src="notification.icon"
                                            :alt="notification.icon"
                                            thumbnail
                                            fluid
                                        />
                                        <feather-icon
                                            v-else
                                            class="text-white"
                                            :icon="notification.icon"
                                        />
                                    </template>
                                    <template v-else>
                                        <feather-icon
                                            class="text-white"
                                            icon="MailIcon"
                                        />
                                    </template>
                                </b-avatar>
                                <!-- <b-avatar
                                    v-if="notification.icon"
                                    size="32"
                                    :src="notification.icon"
                                    :text="notification.icon"
                                    variant="primary"
                                />
                                <b-avatar
                                    v-else
                                    size="32"
                                    variant="primary"
                                    icon="info-circle-fill"
                                /> -->
                            </template>
                            <p class="media-heading">
                                <span class="font-weight-bolder">
                                    {{ notification.title }}
                                </span>
                            </p>
                            <small class="notification-text">{{ notification.body }}</small>
                        </b-media>
                    </b-media>
                </b-link>

                <!-- System Notification Toggler -->
                <!-- <div class="media d-flex align-items-center">
                <h6 class="font-weight-bolder mr-auto mb-0">Notificaciones del sistema</h6>
                <b-form-checkbox
                    :checked="true"
                    switch
                />
            </div> -->

                <!-- System Notifications -->
                <!-- <b-link
                v-for="notification in systemNotifications"
                :key="notification.subtitle"
            >
                <b-media>
                    <template #aside>
                        <b-avatar
                            size="32"
                            :variant="notification.type"
                        >
                            <feather-icon :icon="notification.icon" />
                        </b-avatar>
                    </template>
                    <p class="media-heading">
                        <span class="font-weight-bolder">
                            {{ notification.title }}
                        </span>
                    </p>
                    <small class="notification-text">{{ notification.subtitle }}</small>
                </b-media>
            </b-link> -->
            </vue-perfect-scrollbar>
        </b-overlay>

        <!-- Cart Footer -->
        <b-row class="dropdown-menu-footer m-0">
            <b-col
                sm="12"
                md="9"
            >
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="cargarNotificationes(null)"
                >
                    {{ $t('notifications.read_all') }}
                </b-button>
            </b-col>
            <b-col
                sm="12"
                md="3"
            >
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="deleteNotification(null)"
                >
                    <feather-icon icon="Trash2Icon" />
                </b-button>
            </b-col>
        </b-row>
        <!-- <li class="dropdown-menu-footer">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                block
                @click="cargarNotificationes(null)"
            >
                {{ $t('notifications.read_all') }}
            </b-button>
        </li> -->
    </b-nav-item-dropdown>
</template>

<script>
import { BAvatar, BBadge, BButton, BCol, BLink, BMedia, BNavItemDropdown, BOverlay, BRow } from 'bootstrap-vue'
// WebSockets
import Echo from 'laravel-echo'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'
import VuePerfectScrollbar from '@core/vue-perfect-scrollbar'
import { getUserData } from '@/auth/utils'

import 'pusher-js'

import { defineComponent } from 'vue'

// eslint-disable-next-line import/no-default-export
export default defineComponent({
    components: {
        BNavItemDropdown,
        BBadge,
        BMedia,
        BLink,
        BAvatar,
        VuePerfectScrollbar,
        BButton,
        BOverlay,
        BRow,
        BCol,
    },
    directives: {
        Ripple,
    },
    setup() {
        const systemNotifications = []

        const perfectScrollbarSettings = {
            maxScrollbarLength: 60,
            wheelPropagation: false,
        }

        return {
            systemNotifications,
            perfectScrollbarSettings,
        }
    },
    data() {
        return {
            show: false,
            user_id: getUserData().id,
        }
    },
    computed: {
        ...mapGetters({
            getNotifications: 'auth/getNotifications',
            getNotificationsCount: 'auth/getNotificationsCount',
        }),
    },
    created() {
        this.fetchWebNotificationsCount({ count: true })
    },
    mounted() {
        window.Echo.private(`user.${this.user_id}`).listen(`.user.${this.user_id}`, e => {
            if (e.notifications_count) {
                this.fetchWebNotificationsCount({ count: e.notifications_count })
            }
        })
    },
    beforeMount() {
        window.Echo = new Echo({
            broadcaster: import.meta.env.VITE_BROADCAST_CONNECTION,
            key: import.meta.env.VITE_REVERB_APP_KEY,
            wsHost: import.meta.env.VITE_REVERB_HOST,
            authEndpoint: `${import.meta.env.VITE_BASE_URL}/api/broadcasting/auth`,
            encrypted: true,
            forceTLS: import.meta.env.VITE_REVERB_SCHEME === 'https',
            wsPort: import.meta.env.VITE_REVERB_PORT,
            wssPort: import.meta.env.VITE_REVERB_PORT,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            auth: {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(jwtDefaultConfig.storageTokenKeyName)}`,
                },
            },
        })
    },
    beforeDestroy() {
        window.Echo.private(`user.${this.user_id}`).stopListening(`.user.${this.user_id}`)
        window.Echo.leave(`user.${this.user_id}`)
        window.Echo.connector.pusher.disconnect()
    },
    methods: {
        ...mapActions({
            fetchWebNotifications: 'auth/fetchWebNotifications',
            fetchWebNotificationsCount: 'auth/fetchWebNotificationsCount',
            discardWebNotifications: 'auth/discardWebNotifications',
        }),
        cargarNotificationes(limit = 20) {
            this.show = true
            this.fetchWebNotifications({ limit })
                .then(() => (this.show = false))
                .catch(() => (this.show = false))
        },
        deleteNotification(id) {
            this.discardWebNotifications({ id })
                .then(() => {
                    this.show = true
                    this.fetchWebNotificationsCount({ count: true })
                    this.cargarNotificationes()
                })
                .catch(() => (this.show = false))
        },
    },
})
</script>

<style scoped>
.border-none {
    border: none !important;
}
</style>
